import { cardResource, CardResource } from '@witkac/kartamiejska-resources';
import { Card } from '@witkac/kartamiejska-shared';

import { EntityModule } from '../entity.module';

/**
 * Moduł kart klienta
 *
 * @class ClientCardModule
 * @extends {EntityModule<Card, CardResource>}
 */
class ClientCardsModule extends EntityModule<Card, CardResource> {
  constructor() {
    super(cardResource);
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę kart klienta
       *
       * @param context context
       */
      list: async (context: any): Promise<void> => {
        const list = await this.resource.cardsById(context.rootState.client.id);
        context.commit('saveList', list);
      },
      /**
       * Blokuje wybraną karte
       *
       * @param context context
       * @param id id karty
       */
      block: async (context: any, id: number): Promise<void> => {
        await this.resource.delete(id);
        const list = await this.resource.cardsById(context.rootState.client.id);
        context.commit('saveList', list);
      },
      /**
       * Dodaje encję
       *
       * @param context context
       * @param data dane encji
       */
      add: async (context: any, data: any): Promise<void> => {
        await this.resource.add(data);
        await context.dispatch('list');
      },
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        await this.resource.update(data.id as number, data);
        await context.dispatch('list');
      }
    };
  }
}

export default new ClientCardsModule();
